<template>
  <v-row>
    <v-col cols="12" md="6" lg="3">
      <form-group :validator="$v.form.name" name="name" attribute="fields.name">
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="text"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.name"
            :messages="$t('required')"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="3">
      <form-group
        :validator="$v.form.price"
        name="price"
        attribute="fields.price"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="number"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.price"
            :messages="$t('required')"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="3">
      <form-group
        :validator="$v.form.persons_count"
        name="persons_count"
        attribute="fields.persons_count"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="number"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.persons_count"
            :messages="$t('required')"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="3">
      <form-group
        :validator="$v.form.children_count"
        name="children_count"
        attribute="fields.children_count"
      >
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            type="number"
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.children_count"
            :messages="$t('required')"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>

    <v-col cols="12" md="6">
      <v-switch
        :label="$t('table.visible')"
        :true-value="1"
        :false-value="0"
        v-model="form.visible"
      ></v-switch>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "FirstStep",
  props: {
    form: {
      type: Object,
      default: () => {}
    }
  },
  inject: ["$v"]
};
</script>
